import { cartManager } from './njs/libs/cartManager.njs.js';
import { httpManager } from './njs/libs/httpManager.njs.js';
import { loadingManager } from './njs/libs/loadingManager.njs.js';

import { checkout } from './njs/components/checkout.njs.js';
import { header } from './njs/components/header.njs.js';
import { cart } from './njs/components/cart.njs.js';
import { page } from './njs/components/page.njs.js';

export const sd = angular.module('sd', []);
sd.service('httpManager',httpManager);
sd.service('loadingManager',loadingManager);
sd.service('cartManager',cartManager);

sd.controller('page', page);
sd.controller('cart', cart);
sd.controller('checkout', checkout );
sd.controller('header', header );